/**
 * JS mirror of theme/breakpoints.css @custom-media values.
 * Keep in sync with breakpoints.css when modifying media queries.
 */
export const Breakpoint = {
    MOBILE_PORTRAIT: 'MOBILE_PORTRAIT',
    MOBILE_LANDSCAPE: 'MOBILE_LANDSCAPE',
    TABLET_PORTRAIT: 'TABLET_PORTRAIT',
    TABLET_LANDSCAPE: 'TABLET_LANDSCAPE',
    DESKTOP: 'DESKTOP'
} as const;

export type BreakpointType = (typeof Breakpoint)[keyof typeof Breakpoint];

export const MEDIA_QUERIES: Record<BreakpointType, string> = {
    [Breakpoint.MOBILE_PORTRAIT]: '(max-width: 500px) and (orientation: portrait)',
    [Breakpoint.MOBILE_LANDSCAPE]: '(max-height: 500px) and (orientation: landscape)',
    [Breakpoint.TABLET_PORTRAIT]: '(min-width: 501px) and (orientation: portrait)',
    [Breakpoint.TABLET_LANDSCAPE]:
        '(min-height: 501px) and (max-height: 1024px) and (orientation: landscape)',
    [Breakpoint.DESKTOP]: '(min-width: 1025px)'
};

/** Phones in BOTH orientations — single source for "is this mobile?"
 *  matchMedia checks (mirrors `--mobile, --mobile-landscape`). */
export const MOBILE_QUERY = `${MEDIA_QUERIES[Breakpoint.MOBILE_PORTRAIT]}, ${
    MEDIA_QUERIES[Breakpoint.MOBILE_LANDSCAPE]
}`;

/**
 * Detection order: most specific first.
 * TABLET_LANDSCAPE before DESKTOP because a wide tablet in landscape
 * matches both (min-width: 1025px) and (orientation: landscape).
 * MOBILE_LANDSCAPE before TABLET_PORTRAIT for similar overlap reasons.
 */
export const detectBreakpoint = (): BreakpointType => {
    if (window.matchMedia(MEDIA_QUERIES[Breakpoint.MOBILE_LANDSCAPE]).matches) {
        return Breakpoint.MOBILE_LANDSCAPE;
    }
    if (window.matchMedia(MEDIA_QUERIES[Breakpoint.TABLET_LANDSCAPE]).matches) {
        return Breakpoint.TABLET_LANDSCAPE;
    }
    if (window.matchMedia(MEDIA_QUERIES[Breakpoint.DESKTOP]).matches) return Breakpoint.DESKTOP;
    if (window.matchMedia(MEDIA_QUERIES[Breakpoint.TABLET_PORTRAIT]).matches) {
        return Breakpoint.TABLET_PORTRAIT;
    }
    return Breakpoint.MOBILE_PORTRAIT;
};
